import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Guid } from 'guid-typescript';
import { CsProject } from '../state/cs-project.model';

@Component({
  selector: 'app-cs-project-form',
  templateUrl: './cs-project-form.component.html',
  styleUrls: ['./cs-project-form.component.scss']
})
export class CsProjectFormComponent implements OnChanges {
  @Input() csProject: CsProject;
  @Input() isReadonly = true;

  private projectForm = new FormGroup({
    projectName: new FormControl('', [Validators.required]),
    chargingStationAddressLine1: new FormControl('', [Validators.required]),
    chargingStationPostalCode: new FormControl('', [Validators.required]),
    chargingStationCity: new FormControl('', [Validators.required]),
    projectContactFirstName: new FormControl('', [Validators.required]),
    projectContactLastName: new FormControl('', [Validators.required]),
    customerCompany: new FormControl('', [Validators.required]),
    customerAddressLine1: new FormControl('', [Validators.required]),
    customerPostalCode: new FormControl('', [Validators.required]),
    customerCity: new FormControl('', [Validators.required]),
    customerContactFirstName: new FormControl('', [Validators.required]),
    customerContactLastName: new FormControl('', [Validators.required]),
    customerContactEmail: new FormControl('', [Validators.required, Validators.email]),
    customerContactPhoneNumber: new FormControl('', [Validators.required])
  });

  get projectName(): any {
    return this.projectForm.get('projectName');
  }

  get chargingStationAddressLine1(): any {
    return this.projectForm.get('chargingStationAddressLine1');
  }

  get chargingStationPostalCode(): any {
    return this.projectForm.get('chargingStationPostalCode');
  }

  get chargingStationCity(): any {
    return this.projectForm.get('chargingStationCity');
  }

  get projectContactFirstName(): any {
    return this.projectForm.get('projectContactFirstName');
  }

  get projectContactLastName(): any {
    return this.projectForm.get('projectContactLastName');
  }

  get customerCompany(): any {
    return this.projectForm.get('customerCompany');
  }

  get customerAddressLine1(): any {
    return this.projectForm.get('customerAddressLine1');
  }

  get customerPostalCode(): any {
    return this.projectForm.get('customerPostalCode');
  }

  get customerCity(): any {
    return this.projectForm.get('customerCity');
  }

  get customerContactFirstName(): any {
    return this.projectForm.get('customerContactFirstName');
  }

  get customerContactLastName(): any {
    return this.projectForm.get('customerContactLastName');
  }

  get customerContactEmail(): any {
    return this.projectForm.get('customerContactEmail');
  }

  get customerContactPhoneNumber(): any {
    return this.projectForm.get('customerContactPhoneNumber');
  }

  get isValid(): boolean {
    return this.projectForm.valid;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.csProject?.currentValue) {
      this.initializeForm();
    }
  }

  public discardChanges(): void {
    this.initializeForm();
  }

  public initializeForm(): void {
    this.projectName.setValue(this.csProject.projectName);
    this.chargingStationAddressLine1.setValue(this.csProject.chargingStationAddress.line1);
    this.chargingStationPostalCode.setValue(this.csProject.chargingStationAddress.postalCode);
    this.chargingStationCity.setValue(this.csProject.chargingStationAddress.city);
    this.projectContactFirstName.setValue(this.csProject.projectContact.firstName);
    this.projectContactLastName.setValue(this.csProject.projectContact.lastName);
    this.customerCompany.setValue(this.csProject.customerCompany);
    this.customerAddressLine1.setValue(this.csProject.customerAddress.line1);
    this.customerPostalCode.setValue(this.csProject.customerAddress.postalCode);
    this.customerCity.setValue(this.csProject.customerAddress.city);
    this.customerContactFirstName.setValue(this.csProject.customerContact.firstName);
    this.customerContactLastName.setValue(this.csProject.customerContact.lastName);
    this.customerContactEmail.setValue(this.csProject.customerContact.email);
    this.customerContactPhoneNumber.setValue(this.csProject.customerContact.phoneNumber);
  }


  public getProject(): CsProject {
    return {
      id: this.csProject ? this.csProject.id : Guid.create().toString() as any,
      projectName: this.projectName.value,
      projectContact: {
        firstName: this.projectContactFirstName.value,
        lastName: this.projectContactLastName.value
      },
      chargingStationAddress: {
        line1: this.chargingStationAddressLine1.value,
        postalCode: this.chargingStationPostalCode.value,
        city: this.chargingStationCity.value
      },
      customerCompany: this.customerCompany.value,
      customerAddress: {
        line1: this.customerAddressLine1.value,
        postalCode: this.customerPostalCode.value,
        city: this.customerCity.value
      },
      customerContact: {
        firstName: this.customerContactFirstName.value,
        lastName: this.customerContactLastName.value,
        email: this.customerContactEmail.value,
        phoneNumber: this.customerContactPhoneNumber.value
      },
      createdOn: new Date()
    };
  }
}
